// import CustomerInvoiceTemplate from "./CustomerInvoiceAfterEnd";

// export const handleBrowserPrintAfterEnd = async (orderDetails, invoiceSettings, orderId) => {
//   const printWindow = window.open("", "printWindow", "width=400,height=600");
//   if (printWindow) {
//     const html = await CustomerInvoiceTemplate(orderDetails, invoiceSettings, orderId); // ✅ هنا كان لازم await
//     printWindow.document.open();
//     printWindow.document.write(html);
//     printWindow.document.close();
//     printWindow.focus();

//     // تأكد أن نافذة الطباعة تُغلق بعد انتهاء الطباعة (مع احتياطي)
//     const tryClose = () => {
//       try {
//         if (printWindow && !printWindow.closed) printWindow.close();
//       } catch (e) {
//         // ignore
//       }
//     };

//     // attach both handlers for broader browser support
//     printWindow.onafterprint = tryClose;
//     try {
//       printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
//     } catch (e) {
//       /* ignore */
//     }

//     // احتياطي: أغلق النافذة بعد 12 ثانية إذا لم يتم إغلاقها بواسطة الحدث
//     const fallbackTimer = setTimeout(() => {
//       tryClose();
//     }, 12000);

//     // تأكد إزالة الـ timeout لو تم الإغلاق بالفعل
//     const clearIfClosed = () => {
//       if (!printWindow || printWindow.closed) {
//         clearTimeout(fallbackTimer);
//         try {
//           printWindow.onafterprint = null;
//           printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
//         } catch (e) {}
//       }
//     };

//     // استدعاء الطباعة ثم تحقق دوري إن أُغلقت النافذة
//     printWindow.print();
//     const pollInterval = setInterval(() => {
//       if (!printWindow || printWindow.closed) {
//         clearInterval(pollInterval);
//         clearIfClosed();
//       }
//     }, 500);
//   } else {
//     alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
//   }
// };


import CustomerInvoiceTemplate from "./CustomerInvoiceAfterEnd";

export const handleBrowserPrintAfterEnd = async (orderDetails, invoiceData, orderId) => {
  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  const html = await CustomerInvoiceTemplate(orderDetails, invoiceData, orderId);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  // ✅ انتظر تحميل الصور/الخطوط ثم اطبع
  const safePrint = async () => {
    try {
      // لو السكريبت داخل الـ HTML اتسجل
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        // fallback بسيط
        await new Promise((r) => setTimeout(r, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};
